import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceRoomViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, ScheduledEventViewModel, SchedulerSettingsViewModel } from 'src/app/_models/generatedModels';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ConferenceSchedulerService, OrganizationService } from 'src/app/_services/generatedServices';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventDetailsFlyoutComponent } from './event-details-flyout.component';

@Component({
  selector: 'bxl-conference-schedule-element',
  templateUrl: 'conference-schedule-element.component.html',
})
export class ConferenceScheduleElementComponent implements OnInit {
  initialized = false;
  colWidth = 0;

  timeBlocks = [];
  tempy: number;
  rooms: ConferenceRoomViewModel[];
  events: ScheduledEventViewModel[];
  schedulerSettings: SchedulerSettingsViewModel;
  currentDay: number;
  loading: boolean;
  momentFn = moment;
  @Input() conference: ConferenceViewModel;
  @Input() element:PageElementViewModel;
  constructor(private router: Router, private route: ActivatedRoute, private schedulerService: ConferenceSchedulerService, private modalService: NgbModal, private organizationService: OrganizationService, private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((queryParams) => {
      this.currentDay = 0;

      if (queryParams.get('day')) {
        this.currentDay = parseInt(queryParams.get('day')) - 1;
      }

      this.reloadEvents();
    });
  }

  showDetails(evt: ScheduledEventViewModel) {
    const modalRef = this.modalService.open(EventDetailsFlyoutComponent, { size: 'lg', keyboard: false, ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.event = evt;
    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }

  reloadEvents() {
    this.loading = true;
    this.schedulerService.getScheduledEvents(this.conference.organizationId.toString(), this.conference.id, this.currentDay).subscribe((schedulerSettings) => {
      this.schedulerSettings = schedulerSettings;
      this.events = this.schedulerSettings.events;

      this.organizationService.getRoomsForConference(this.conference.id.toString()).subscribe((rooms) => {
        this.rooms = rooms.filter((x) => !x.specificDates || x.specificDates.length == 0 || x.specificDates.find((y) => y == this.schedulerSettings.dayLabels[this.currentDay]));
        this.calculateColumns(window.innerWidth - 40);
        console.log(window.innerWidth);
        this.calculateTimes();

        this.tempy = 0;
        this.updateEvents();
        this.loading = false;
        this.initialized = true;
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.calculateColumns(event.target.innerWidth - 40);
    this.updateEvents();
  }

  calculateColumns(totalWith) {
    this.colWidth = (totalWith - 80) / this.rooms.length;
    console.log(this.colWidth);
  }

  nextDay() {
    this.currentDay++;
    this.reloadEvents();
  }

  previousDay() {
    this.currentDay--;
    this.reloadEvents();
  }

  calculateTimes() {
    this.timeBlocks = [];
    for (let hour = this.schedulerSettings.startHour; hour < this.schedulerSettings.endHour; hour++) {
      this.timeBlocks.push(moment({ hour }).format('h:mm A'));
      this.timeBlocks.push(
        moment({
          hour,
          minute: 30,
        }).format('h:mm A')
      );
    }
  }

  updateEvents() {
    this.events.forEach((event) => {
      var columnIndex = this.rooms.findIndex((x) => x.id == event.room.id);
      if (columnIndex != -1) {
        event.xCoordinate = 80 + columnIndex * this.colWidth;
        event.yCoordinate = event.timeIn5MinBlocks * 7;
      }
    });

    console.log(this.events);
  }
}
